<template>
  <ChecklistModal
    :title="$tc('residential', 2)"
    :value="internalValue"
    @input="updateFilter"
    :items="fetchResidentials"
    :transform="item => ({ value: item.id, label: `${this.$tc('residential')} ${item.number}`, project: item.project })"
    :group-by="{ path: 'project.id', label: 'project.name' }"
  >
    <template #input="{ items }">
      <div class="elder-input">
        <label class="elder-input__label">{{ $tc('residential', 2) }}</label>
        <ButtonComponent class="elder-input__wrapper" :icon="['fal', 'home']" icon-placement="left">
          <template #label>
            <span v-html="getLabel(items)"></span>
            <Badge class="ml-1" v-if="items.length > limit" :value="`+ ${items.length - limit}`" />
            <FontAwesomeIcon class="ml-1" :icon="['fal', 'angle-down']" size="sm" />
          </template>
        </ButtonComponent>
      </div>
    </template>
  </ChecklistModal>
</template>

<script>
import ProjectApi from '@/api/Project'
import fetch from '@/fetch'

import { ButtonComponent } from 'vue-elder-button'
import ChecklistModal from '@/components/Select/ChecklistModal'
import Badge from '@/components/Badge'

export default {
  props: ['value', 'options'],
  watch: {
    valueComp() {
      if (this.valueComp.length && !this.internalValue.length) return this.fetchInitial()
      this.internalValue = this.internalValue.filter(i => this.valueComp.includes(i.id))
    },
  },
  data() {
    return {
      internalValue: [],
      limit: 1,
    }
  },
  computed: {
    valueComp() {
      return this.value instanceof Array ? this.value : [this.value].filter(Boolean)
    },
  },
  methods: {
    getLabel(items) {
      return items.length
        ? `${items
            .slice(0, this.limit)
            .map(({ name }) => name)
            .join(', ')}`
        : this.$t('select')
    },
    fetchResidentials(filter) {
      return ProjectApi.get(
        { filter: { ...filter, ...(this.$path('filter', this.options) || {}) } },
        { query: 'ProjectResidentialSearch' },
      ).then(projects => {
        let result = []

        for (let project of projects) {
          for (let residential of project.residentials) {
            result.push({
              ...residential,
              project,
            })
          }
        }

        return result
      })
    },
    updateFilter(value) {
      this.internalValue = value
      this.$emit(
        'input',
        value.map(i => i.id),
      )
    },
    fetchInitial() {
      let params = new URLSearchParams()
      params.append('field.id', 'id')
      params.append('field.name', 'displayName|name')
      this.valueComp.forEach(v => params.append('ids', v))

      fetch(`/api/resource/residential?${params.toString()}`)
        .then(res => res.json())
        .then(data => (this.internalValue = data))
    },
  },
  components: {
    ChecklistModal,
    ButtonComponent,
    Badge,
  },
}
</script>
